import { AppHeader } from "@/components/AppHeader";
import { JobEntryForm } from "@/components/JobEntryForm";
import { SectionLabel } from "@/components/FormField";
import { useAuth } from "@/context/AuthContext";

export default function JobEntryPage() {
  const { user } = useAuth();
  const links = user?.role === "admin" ? [{ to: "/admin", label: "Dashboard", testId: "nav-admin-dashboard-link" }] : [];
  return (
    <div className="min-h-screen bg-[#030712] cyber-grid">
      <AppHeader links={links} />
      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <div className="rise-in mb-8">
          <SectionLabel>manual entry</SectionLabel>
          <h1 className="font-display text-3xl sm:text-4xl uppercase tracking-wider mt-3">Log a tow job</h1>
          <p className="text-sm text-slate-400 mt-2">For phone-in, walk-up and completed jobs.</p>
        </div>
        <div className="rise-in" style={{ animationDelay: "80ms" }}>
          <JobEntryForm />
        </div>
      </main>
    </div>
  );
}
